import { APP_LINKS } from "@/data/content";

export const AliveApp = () => {
  return (
    <section className="bg-white py-16 md:py-20" data-testid="alive-app-section">
      <div className="mx-auto max-w-[1100px] px-6">
        <h2 className="text-center text-3xl font-extrabold tracking-tight text-slate-800 md:text-4xl">
          Descarcă aplicația Alive App
        </h2>
        <div className="mx-auto mt-5 h-1.5 w-20 rounded-full bg-[#2f68b0]" />
        <h3 className="mx-auto mt-6 max-w-3xl text-center text-lg font-semibold text-slate-500 md:text-xl">
          Ai acces instant la legitimația ta digitală ISIC, reduceri, concursuri &amp; more!
        </h3>

        <div className="mt-10 flex flex-col items-center justify-center gap-6 sm:flex-row">
          <a
            href={APP_LINKS.appStore}
            target="_blank"
            rel="noopener noreferrer"
            className="transition-transform duration-300 hover:-translate-y-1"
            data-testid="app-store-link"
          >
            <img src="/assets/app-store.png" alt="Descarcă din App Store" className="h-[58px] w-auto" />
          </a>
          <a
            href={APP_LINKS.googlePlay}
            target="_blank"
            rel="noopener noreferrer"
            className="transition-transform duration-300 hover:-translate-y-1"
            data-testid="google-play-link"
          >
            <img src="/assets/google-play.png" alt="Descarcă din Google Play" className="h-[58px] w-auto" />
          </a>
        </div>
      </div>
    </section>
  );
};
